import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import WeeklyWinners from "./WeeklyWinners";
import SeasonWinners from "./SeasonWinners";
import LeagueInsights from "./LeagueInsights";

function Panel({ children, className = "" }) {
  return <section className={`dashboard-panel ${className}`}>{children}</section>;
}

function Home() {
  return (
    <Box className="league-dashboard">
      <header className="league-hero">
        <div>
          <p className="eyebrow">Fantasy football dashboard</p>
          <h1>The League</h1>
          <p className="hero-copy">
            Track weekly peaks, season records, and the race for the playoffs.
          </p>
        </div>
        <div className="hero-mark" aria-hidden="true">
          <span>FF</span>
        </div>
      </header>

      <Grid container spacing={3} alignItems="flex-start">
        <Grid item xs={12} lg={6}>
          <Panel><WeeklyWinners /></Panel>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Panel><SeasonWinners /></Panel>
        </Grid>
        <Grid item xs={12}>
          <LeagueInsights />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Home;
